@if (state()) {
    <!-- #region header -->
    <div class="p-12:b md:p-16:b lg:p-24:b">
        @if (price() > 0) {
            <app-price-display-card
                [price]="price()"
                [bannerText]="product().fullTitle"
                [settlementPeriod]="hasMonthlySettlementPeriod() ? 'month' : 'year'"
                [taxInfo]="product().orderConfig.taxInfo"
            >
            </app-price-display-card>
        }
    </div>
    <!-- #endregion -->

    <!-- #region contractPeriod -->
    @if (state().completedSteps.includes('laufzeit')) {
        @let contract = state().contract;
        <div class="p-12:t md:p-16:t lg:p-24:t">
            <h4 class="float:l">Vertragslaufzeit</h4>
            <button
                class="btn-link float:r"
                type="button"
                (click)="goToStep('laufzeit')"
                title="Vertragslaufzeit ändern"
            >
                <small>ändern</small>
            </button>
            <dl class="clearfix">
                <dt>Laufzeit</dt>
                <dd>
                    {{ contract.contractPeriod + ' Monat' + (contract.contractPeriod === 1 ? '' : 'e') }}
                </dd>
                <dt>Vertragsbeginn</dt>
                <dd>{{ contract.contractStart }}</dd>
            </dl>
        </div>
    }
    <!-- #endregion -->

    <!-- #region contract start date -->
    @if (state().completedSteps.includes('vertragsbeginn')) {
        <div class="p-12:t md:p-16:t lg:p-24:t">
            <h4 class="float:l">Vertragsbeginn</h4>
            <button
                class="btn-link float:r"
                type="button"
                (click)="goToStep('vertragsbeginn')"
                title="Vertragsbeginn ändern"
            >
                <small>ändern</small>
            </button>
            <dl class="clearfix">
                <dt>Vertragsbeginn</dt>
                <dd>{{ state().contract.contractStart }}</dd>
            </dl>
        </div>
    }
    <!-- #endregion -->

    <!-- #region insuredObjects -->
    @if (state().completedSteps.includes('versicherte-objekte')) {
        <div class="p-12:t md:p-16:t lg:p-24:t">
            <h4 class="float:l">Versicherte {{ product().insuredObjectsForm?.objectDescriptionPlural }}</h4>
            <button
                class="btn-link float:r"
                type="button"
                (click)="goToStep('versicherte-objekte')"
                title="Angaben zu versicherten Objekten ändern"
            >
                <small>ändern</small>
            </button>
            <app-summary-insured-objects
                [insuredObjects]="state().insuredObjects"
                [insuredObjectsConfig]="product().insuredObjectsForm"
            ></app-summary-insured-objects>
        </div>
    }
    <!-- #endregion -->

    <!-- #region insuredBike -->
    @if (state().completedSteps.includes('versichertes-fahrrad')) {
        <div class="p-12:t md:p-16:t lg:p-24:t">
            <h4 class="float:l">Versichertes {{ product().insuredObjectsForm?.objectDescriptionSingular }}</h4>
            <button
                class="btn-link float:r"
                type="button"
                (click)="goToStep('versichertes-fahrrad')"
                title="Angaben zum Rad ändern"
            >
                <small>ändern</small>
            </button>
            <app-summary-insured-objects
                [insuredObjects]="state().insuredObjects"
                [insuredObjectsConfig]="product().insuredObjectsForm"
            ></app-summary-insured-objects>
        </div>
    }
    <!-- #endregion -->

    <!-- #region insuredObjects Electronics B2C -->
    @if (state().completedSteps.includes('versichertes-geraet')) {
        @let device = state().insuredObjects[0];
        <div class="p-12:t md:p-16:t lg:p-24:t">
            <h4 class="float:l">Versichertes Gerät</h4>
            <button
                class="btn-link float:r"
                type="button"
                (click)="goToStep('versichertes-geraet')"
                title="Angaben zu versicherten Geräten ändern"
            >
                <small>ändern</small>
            </button>
            <dl class="clearfix">
                <dt>Gerätetyp:</dt>
                <dd>{{ device.type }}</dd>
                <dt>{{ isAppliance ? 'Gerätetyp 2' : 'Hersteller' }}:</dt>
                <dd>{{ device.description }}</dd>
                <dt>{{ isAppliance ? 'Marke' : 'Modell' }}:</dt>
                <dd>{{ device.model }}</dd>
                <dt>Kaupfpreis:</dt>
                <dd>{{ device.value | commaToDot | currency: 'EUR' }}</dd>
                <dt>Kaufdatum:</dt>
                <dd>{{ device.date }}</dd>
                <dt>{{ isSmartphone ? 'IMEI' : 'Seriennummer' }}:</dt>
                <dd>{{ device.detail || 'keine Angabe' }}</dd>
            </dl>
            @if (state().insuredObjects[1]) {
                @let secondDevice = state().insuredObjects[1];
                <dl class="clearfix m-12:t md:m-16:t lg:m-24:t">
                    <dt>Gerätetyp:</dt>
                    <dd>{{ secondDevice.type }}</dd>
                    <dt>Hersteller:</dt>
                    <dd>{{ secondDevice.description }}</dd>
                    <dt>Modell:</dt>
                    <dd>{{ secondDevice.model }}</dd>
                    <dt>Kaupfpreis:</dt>
                    <dd>{{ secondDevice.value | commaToDot | currency: 'EUR' }}</dd>
                    <dt>Seriennummer:</dt>
                    <dd>{{ secondDevice.detail || 'keine Angabe' }}</dd>
                </dl>
            }
        </div>
    }
    <!-- #endregion -->

    <!-- #region insurants (single) -->
    @if (state().completedSteps.includes('versicherte-person')) {
        @let insurant = state().insurants[0];
        <div class="p-12:t md:p-16:t lg:p-24:t">
            <h4 class="float:l">Versicherte Person</h4>
            <button
                class="btn-link float:r"
                type="button"
                (click)="goToStep('versicherte-person')"
                title="Angaben zur versicherten Person ändern"
            >
                <small>ändern</small>
            </button>
            @if (insurant && !insurant.isInsuree) {
                <dl class="clearfix">
                    <dt>Vorname</dt>
                    <dd>{{ insurant.firstName }}</dd>
                    <dt>Nachname</dt>
                    <dd>{{ insurant.lastName }}</dd>
                    <dt>Geb. am</dt>
                    <dd>{{ insurant.dateOfBirth }}</dd>
                </dl>
            }
            <div class="clearer inline-block">
                @if (!insurant || insurant.isInsuree) {
                    <small> Der Versicherungsnehmer ist die versicherte Person </small>
                }
            </div>
        </div>
    }
    <!-- #endregion -->

    <!-- #region insurants (multiple) -->
    @if (state().completedSteps.includes('versicherte-personen')) {
        <div class="p-12:t md:p-16:t lg:p-24:t">
            <h4 class="float:l">Versicherte Personen</h4>
            <button
                class="btn-link float:r"
                type="button"
                (click)="goToStep('versicherte-personen')"
                title="Angaben zu versicherten Personen ändern"
            >
                <small>ändern</small>
            </button>
            <app-summary-insurants
                [insurants]="state().insurants"
                [insurantsFormConfig]="product().insurantsForm"
            ></app-summary-insurants>
        </div>
    }
    <!-- #endregion -->

    <!-- #region billing address -->
    @if (state().completedSteps.includes('rechnungsadresse')) {
        @let addr = state().billingAddress;
        <div class="p-12:t md:p-16:t lg:p-24:t">
            <h4 class="float:l">Rechnungsadresse</h4>
            <button
                class="btn-link float:r"
                type="button"
                (click)="goToStep('rechnungsadresse')"
                title="Rechnungsadresse ändern"
            >
                <small>ändern</small>
            </button>
            <dl class="clearfix">
                @if (isCompany()) {
                    <dt>Schule/Verein/Firma</dt>
                    <dd>{{ addr?.company }}</dd>
                    <dt>Ansprechpartner</dt>
                    <dd>{{ addr?.firstName + ' ' + addr?.lastName }}</dd>
                } @else {
                    <dt>Vorname</dt>
                    <dd>{{ addr?.firstName }}</dd>
                    <dt>Nachname</dt>
                    <dd>{{ addr?.lastName }}</dd>
                }

                <dt>Straße und Hausnr.</dt>
                <dd>{{ addr?.street }}</dd>
                <dt>PLZ, Stadt</dt>
                <dd>{{ addr?.zip }} {{ addr?.city }}</dd>

                @if (addr?.state) {
                    <dt>Bundesland</dt>
                    <dd>{{ addr?.state }}</dd>
                }

                <dt>E-Mail</dt>
                <dd>{{ addr?.mail }}</dd>
                <dt>Telefon</dt>
                <dd>{{ addr?.phone }}</dd>

                @if (!isCompany()) {
                    <dt>Geb. am</dt>
                    <dd>{{ addr?.dateOfBirth }}</dd>
                }
            </dl>
        </div>
    }
    <!-- #endregion -->

    <!-- #region payment -->
    @if (state().completedSteps.includes('zahlungsdaten')) {
        @let payment = state().payment;
        <div class="p-12:t md:p-16:t lg:p-24:t">
            <h4 class="float:l">Zahlungsdaten</h4>
            <button
                class="btn-link float:r"
                type="button"
                (click)="goToStep('zahlungsdaten')"
                title="Zahlungsdaten ändern"
            >
                <small>ändern</small>
            </button>
            <dl class="clearfix">
                <dt>Kontoinhaber</dt>
                <dd>{{ payment?.accountHolder }}</dd>
                <dt>IBAN</dt>
                <dd>{{ payment?.iban | mangle }}</dd>

                @if (payment.bic) {
                    <dt>BIC</dt>
                    <dd>{{ payment?.bic | mangle: 2 }}</dd>
                }
                <dt>Kreditinstitut</dt>
                <dd>{{ payment?.nameOfBank }}</dd>
            </dl>
        </div>
    }
    <!-- #endregion -->
}
